import { createHumanMessage } from '@atlassian/conversation-assistant-service/services/assistance-service/utils/data';
import { type StoreHuman } from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const createStoreHuman = (...args: Parameters<typeof createHumanMessage>): StoreHuman => ({
	type: 'HUMAN',
	content: createHumanMessage(...args),
});
